import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Buttons/Button";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig, SelectListOption } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import WorkflowModel from "../../../models/WorkflowModel";
import WorkflowTaskModel from "../../../models/WorkflowTaskModel";
import DataService from "../../../services/data.service";
import { ProjectPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface StartWorkflowModel {
    projectId: number
    workflowDefinitionId: number
}

const StartWorkflowPopup: React.FC<ProjectPopupProps> = ({ show, onHide, projectId, refreshDataCounter }) => {
    const [title, setTitle] = useState<string>();
    const [serverErrors, setServerErrors] = useState<DataResult<StartWorkflowModel>>({ isSuccesful: true, messages: [], data: undefined });
    const [workflowDefinitions, setWorkflowDefinitions] = useState<SelectListOption[]>()
    //const workflowDefinitions = useSelectListOptions('api/v1/selectlist/ProjectWorkflowDefinitions?projectId=' + projectId, '-- Select workflow');
    const [showSpinner, setShowSpinner] = useState(false)
    const { handleResult, handleException } = useNotifications();
    const { translate } = useTranslations();
    const navigate = useNavigate();

    const [formData, setFormData] = useState<StartWorkflowModel>({
        projectId: projectId,
        workflowDefinitionId: 0
    });

    useEffect(() => {
        translate('Start project workflow').then(translated => setTitle(translated));
        translate('-- Select workflow')
            .then(translated => DataService.get<SelectListOption[]>('api/v1/selectlist/ProjectWorkflowDefinitions?projectId=' + projectId + '&nullOption=' + translated)
                .then(response => setWorkflowDefinitions(response)));
    }, [projectId, refreshDataCounter]);

    function submit() {
        if (formData) {
            setShowSpinner(true)
            DataService
                .post<DataResult<WorkflowModel>>(`api/v1/Workflow/StartWorkflow`, formData)
                .then(response => {
                    setShowSpinner(false)
                    handleResult(response);
                    if (response.isSuccesful === true) {
                        if (response.data) {
                            setShowSpinner(true)
                            DataService
                                .get<WorkflowTaskModel[]>('api/v1/WorkflowTasks/ByWorkflow/' + response.data.id)
                                .then(response => {
                                    setShowSpinner(false)
                                    //console.log('tasks', response)
                                    var activeTasks = response.filter(x => x.completedOn == null)
                                    if (activeTasks.length > 0)
                                        navigate('/plm/Workflow/Task/' + activeTasks[0].id)
                                    else if (onHide)
                                        onHide()
                                })
                                .catch(e => { handleException(e); setShowSpinner(false); });
                        }
                        else if (onHide)
                            onHide();
                    }
                })
                .catch(e => { handleException(e); setShowSpinner(false); });
        }
    }

    function onFieldChanged(name: string, value: string): void {
        formData[name] = value;
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'workflowDefinitionId', label: 'Workflow', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return <>
        <Modal show={show} onHide={onHide} size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SelectListField {...getFieldProps('workflowDefinitionId')} options={workflowDefinitions} />
            </Modal.Body>
            <Modal.Footer>
                <Button {...getSubmitButtonProps()} text='Start workflow' fill />
            </Modal.Footer>
        </Modal>
        {showSpinner && <SpinnerOverlay />}
    </>
}
export default StartWorkflowPopup;